
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
  computed: {},
  filters: {},
  watch: {}
})
export default class ModificarAsegurados extends Vue {
  title: string = "Modificar Asegurados";
  fields: any = {
    insured_fullname: { value: "", label: "Nombre de los Asegurados" },
    brand: { value: "", label: "Marca" },
    licenseplate: { value: "", label: "Placa" },
    activity: { value: "", label: "Actividad de los Asegurados" },
    model: { value: "", label: "Modelo" },
    vehicle_type: { value: "", label: "Tipo de Vehículo" },
    commodity: { value: "", label: "Tipo Mercadería" },
    country: { value: "", title: "" },
    province: { value: "", label: "Estado / Provincia" },
    city: { value: "", label: "Ciudad" },
    address: { value: "", label: "Dirección" },
    risks: { value: "", label: "Riesgos" }
  };
  countries: any = [];
  async mounted() {
    this.loadRequest();
  }
  async loadRequest() {
    const response: any = await (this.$root as any)._post(
      `requests/one/${this.$route.params.id}`,
      {
        models: "companies,branches,control_zones,subscriptors,currencies"
      }
    );
    let res = response.data[0].requests_details[0];
    for (const key in this.fields) {
      if (key !== "country") {
        this.fields[key] = { ...this.fields[key], value: res[key] };
      }
    }
    this.loadCountries(res.country);
  }
  async loadCountries(id) {
    const response: any = await (this.$root as any)._get("countries/all");
    this.countries = response.data.map(c => ({ value: c.id, title: c.title }));
    let country = this.countries.filter(country => country.value === id);
    if (country.length) this.fields.country = country[0];
  }

  async save() {
    try {
      let data = {};
      Object.keys(this.fields).forEach(field => {
        data[field] = this.fields[field].value;
      });
      const response: any = await (this.$root as any)._put(
        `requests/editDetails/${this.$route.params.id}`,
        data
      );
      if (response.error) {
        (this.$root as any).notify(response.error, "error");
      } else {
        this.$router.go(-1);
      }
    } catch (e) {
      console.log(e);
      (this.$root as any).notify("No se modificar los asegurados.", "error");
    }
  }
}
